import { UserPermission } from 'src/models/Settings.model';

export const getFirstAvailablePage = (userPermission: UserPermission) =>
  userPermission.create ? '/session-form' : '/results';

export const getSessionPage = (_: unknown, location: { pathname: string }) => {
  const pages = [
    '/',
    '/session-form',
    '/session-hint',
    '/session-preview',
    '/diabetes-data',
  ];
  return pages.includes(location.pathname);
};
